import { call, put, select, takeLatest } from 'redux-saga/effects';

import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import * as $auth from 'modules/auth';
import * as api from '../api';
import * as actions from '../actions';

const getArtProductsFromArtsets = (artsets) => {
  return artsets.Records[0].Products;
};

export const fetchArtProducts = function* () {
  try {
    const token = yield select($auth.getToken);
    const publisherId = yield select($auth.getSelectedPublisherId);
    const artsets = yield call(api.fetchArtsets, { token, publisherId });
    const artProducts = getArtProductsFromArtsets(artsets);
    return artProducts;
  } catch {
    return [];
  }
};

const fetchArtProductsRequest = function* () {
  yield put($ui.setTrue(UI.Arts.IsFetching)());

  const artProducts = yield call(fetchArtProducts);
  yield put(actions.fetchArtProductsDone(artProducts));

  yield put($ui.setFalse(UI.Arts.IsFetching)());
};

export const fetchArtsSaga = function* () {
  yield takeLatest(actions.fetchArtProducts, fetchArtProductsRequest);
};
